import mwhStore from './MWhReportv2/mwhStore';

export default {
  namespaced: true,
  modules: {
    mwhStore,
  },
};